// extracted by mini-css-extract-plugin
export var actions = "_mc-5";
export var assistantBubble = "_mc-3";
export var assistantRow = "_mc-6";
export var bubble = "_mc-0";
export var humanAvatar = "_mc-4";
export var inlineToolCard = "_mc-1";
export var userBubble = "_mc-2";